import { styled, theme } from '@notino/react-styleguide';

export const StoreTitle = styled.p`
  ${theme.typography.labelRegular400}
  margin-bottom: 0.25rem;
`;

export const StoreDescription = styled.span`
  font-weight: 300;
  ${theme.typography.labelRegular400}
  color:${theme.color.text.tertiary};
  padding-bottom: 0.25rem;
`;

export const StoreStockAvailabilityWrapper = styled.div`
  color: ${theme.color.text.positive};
  ${theme.typography.labelRegular400}
`;
